import Line         from "./Line.js"
import {mapGetters} from "vuex"
import moment       from "moment/moment.js"

export default {
  name: 'OrderChart',
  extends: Line,
  props: ['days', 'endDay', 'startDay', 'dataType'],
  computed: Object.assign({}, mapGetters(['allNonVoidedOrders', 'paypalOrders', 'cardOrders', 'pastOrders']), {
    chartData() {
      let startDay  = moment(this.startDay).startOf('day')
      let endDay    = moment(this.endDay).endOf('day')
      let daysDelta = endDay.diff(startDay, 'days')

      let days = []
      for (let x = 0; x <= daysDelta; x++) {
        if (x === 0) {
          days.push(endDay.subtract(daysDelta, 'days').format('MM/DD/YY'))
        }
        else {
          days.push(endDay.add(1, 'days').format('MM/DD/YY'))
        }
      }

      let allOrders              = []
      let allOrdersCount         = 0
      let allOrdersRevenue       = [];
      let allOrdersTotalRevenue  = 0;
      let cardOrders             = []
      let paypalOrders           = []
      let pastOrders             = []
      let pastOrdersCount        = 0
      let pastOrdersRevenue      = [];
      let pastOrdersTotalRevenue = 0;
      for (let x = 0; x < days.length; x++) {
        allOrders[x]           = 0
        allOrdersRevenue[x]    = 0
        allOrdersTotalRevenue  = 0
        cardOrders[x]          = 0
        paypalOrders[x]        = 0
        pastOrders[x]          = 0
        pastOrdersRevenue[x]   = 0
        pastOrdersTotalRevenue = 0
      }

      for (let orderIndex in this.allNonVoidedOrders) {
        let order      = this.allNonVoidedOrders[orderIndex]
        let orderDate  = order.created_at.substr(5, 2)
                         + '/' + order.created_at.substr(8, 2)
                         + '/' + order.created_at.substr(2, 2);
        let orderTotal = (order.discounted_total !== null && parseFloat(order.discounted_total) !== 0)
          ? parseFloat(order.discounted_total)
          : parseFloat(order.total);
        for (let x = 0; x < days.length; x++) {
          let date = days[x];
          if (date === orderDate) {
            if (order.payment_method === 'Paypal') {
              paypalOrders[x] = paypalOrders[x] + 1
            }
            else {
              cardOrders[x] = cardOrders[x] + 1
            }
            allOrders[x] = allOrders[x] + 1
            allOrdersCount++;
            allOrdersRevenue[x]   = allOrdersRevenue[x] + orderTotal
            allOrdersTotalRevenue = allOrdersTotalRevenue + orderTotal
          }
        }
      }

      for (let pastOrderIndex in this.pastOrders) {
        let pastOrder      = this.pastOrders[pastOrderIndex]
        let pastOrderDate  = pastOrder.created_at.substr(5, 2)
                             + '/' + pastOrder.created_at.substr(8, 2)
                             + '/' + (parseInt(pastOrder.created_at.substr(2, 2)) + 1);
        let pastOrderTotal = (pastOrder.discounted_total !== null && parseFloat(pastOrder.discounted_total) !== 0)
          ? parseFloat(pastOrder.discounted_total)
          : parseFloat(pastOrder.total);
        for (let x = 0; x < days.length; x++) {
          let date = days[x];
          if (date === pastOrderDate) {
            pastOrders[x] = pastOrders[x] + 1
            pastOrdersCount++;
            pastOrdersRevenue[x]   = pastOrdersRevenue[x] + pastOrderTotal
            pastOrdersTotalRevenue = pastOrdersTotalRevenue + pastOrderTotal
          }
        }
      }

      return {
        labels: days,
        thisYear: moment().year(),
        allOrders,
        allOrdersCount,
        allOrdersRevenue,
        allOrdersTotalRevenue,
        cardOrders,
        paypalOrders,
        lastYear: moment().subtract(1, 'years').year(),
        pastOrders,
        pastOrdersCount,
        pastOrdersRevenue,
        pastOrdersTotalRevenue,
      }
    }
  }),

  mounted() {
    let titleText = [];
    let datasets  = []
    if (this.dataType === 'order_comparison') {
      titleText = [
        this.chartData.thisYear + ' ORDERS: ' + this.chartData.allOrdersCount,
        this.chartData.lastYear + ' ORDERS: ' + this.chartData.pastOrdersCount
      ];
      datasets  = [
        {
          label: 'Current Season',
          backgroundColor: 'rgba(50, 140, 200, 0.5)',
          lineTension: 0,
          pointRadius: 6,
          data: this.chartData.allOrders
        },
        {
          label: 'Previous Season',
          backgroundColor: 'rgba(180, 20, 20, 0.5)',
          lineTension: 0,
          pointRadius: 6,
          data: this.chartData.pastOrders
        },
      ];
    }
    else if (this.dataType === 'revenue_comparison') {
      titleText = [
        'CURRENT TOTAL: $' + Math.round(this.chartData.allOrdersTotalRevenue * 100) / 100,
        'PREVIOUS TOTAL: $' + Math.round(this.chartData.pastOrdersTotalRevenue * 100) / 100
      ]
      datasets  = [
        {
          label: 'Current Season',
          backgroundColor: 'rgba(50, 140, 200, 0.5)',
          lineTension: 0,
          pointRadius: 6,
          data: this.chartData.allOrdersRevenue
        },
        {
          label: 'Previous Season',
          backgroundColor: 'rgba(180, 20, 20, 0.5)',
          lineTension: 0,
          pointRadius: 6,
          data: this.chartData.pastOrdersRevenue
        },
      ];
    }
    else {
      datasets = [
        {
          label: 'PayPal Orders',
          backgroundColor: 'rgba(180, 50, 30, 0.5)',
          lineTension: 0,
          pointRadius: 4,
          data: this.chartData.paypalOrders
        },
        {
          label: 'Card Orders',
          backgroundColor: 'rgba(30, 50, 180, 0.5)',
          lineTension: 0,
          pointRadius: 4,
          data: this.chartData.cardOrders
        },
        {
          label: 'All Orders',
          backgroundColor: 'rgba(50, 140, 200, 0.5)',
          lineTension: 0,
          pointRadius: 4,
          data: this.chartData.allOrders
        }
      ];
    }
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: this.chartData.labels,
      datasets,
    }, {
      responsive: true,
      title: {
        display: true,
        text: titleText
      },
      legend: {
        display: true,
        position: 'bottom',
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    })

  }
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/components/charts/orderChart.js
// module id = 230
// module chunks = 0